import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { ApiRequestError } from './lib/api';
import { createEmbeddedRouter, createStandaloneRouter } from './app/router';
import { isEmbedded } from './lib/embedded';
import { ToastProvider } from './ui/Toast';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Don't retry client errors (401, 404, validation) — only transient failures.
      retry: (count, err) =>
        count < 2 && !(err instanceof ApiRequestError && err.status >= 400 && err.status < 500),
    },
  },
});

// One bundle, two entry pages: /shopify/* is the app embedded in Shopify admin.
const router = isEmbedded() ? createEmbeddedRouter() : createStandaloneRouter();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
